import bus from '../../shared/eventbus';

const defaultParams = {};

bus.addEventListener('switched-company', e => {
    defaultParams['company'] = e.detail;
});

/**
 * Build a URL from a route name and parameters.
 * @param {string} routeName
 * @param {object} parameters
 */
export default (routeName, parameters = {}) => {

    parameters = { ...defaultParams, ...parameters };

    var route = Jobtoolz.routes[routeName];

    if ( route === undefined ) {
        console.error('Undefined route:', routeName )
    }

    // Replace provided parameters.
    Object.keys(parameters)
    .forEach( key => route = route.replace( new RegExp( '{' + key + '\\??}' ), parameters[key] ));

    // Remove leftover optional parameters.
    return window.location.protocol + '//' + route.replace( /\/{[a-zA-Z]+\?}/, '' );
}
